"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductById = void 0;

var _products = require("./products.reducer");

var getProductsState = function getProductsState(state) {
  return state.modules.campaignSettings.entities.products;
};

var selectors = _products.productsAdapter.getSelectors(getProductsState);

var getProductById = selectors.getById;
exports.getProductById = getProductById;